import cn from 'classnames'
import React from 'react'
import { Stack } from '../Stack/Stack.tsx'
import { SkeletonType } from './SkeletonType.ts'
import styles from './skeletonPlaceHolder.module.less'

interface Props {
    type?: SkeletonType
    color?: string
    rowsCount?: number
    direction?: 'column' | 'row'
    height?: number | string
    width?: number | string
    maxWidth?: number | string
    minWidth?: number | string
    borderRadius?: number | string
    gap?: number
    wrap?: boolean
}

export const SkeletonPlaceHolder: React.FC<Props> = ({
    borderRadius,
    maxWidth,
    minWidth,
    height,
    width,
    type = SkeletonType.text,
    rowsCount,
    direction = 'column',
    wrap = false,
    gap,
    color
}) =>
    rowsCount ? (
        <Stack direction={direction} style={{ flexWrap: wrap ? 'wrap' : undefined }} gap={gap ?? 8}>
            {Array.from({ length: rowsCount }).map((_, i) => (
                <div
                    key={i}
                    style={{ height, width, maxWidth, minWidth, borderRadius, backgroundColor: color }}
                    className={cn(styles.root, styles[type])}
                />
            ))}
        </Stack>
    ) : (
        <div style={{ height, width, borderRadius, backgroundColor: color }} className={cn(styles.root, styles[type])} />
    )
